import React from 'react';
import cvFile from '../assets/files/Andrea_Massaro_CV.pdf';
import {
  FaCalendarAlt,
  FaEnvelopeOpenText,
  FaFacebookF,
  FaLinkedinIn,
  FaMapMarkerAlt,
  FaMobileAlt,
  FaGoogle,
} from 'react-icons/fa';
import img from '../assets/images/about/avatar_new.jpg';
import downloadIcon from '../assets/images/download.png';

const HomeCard = () => {
  return (
    <div>
      <div className='w-full mb-6 lg:mb-0  mx-auto relative bg-white text-center dark:bg-[#111111] px-6 rounded-[20px] mt-[180px] md:mt-[220px] lg:mt-0 '>
        <img
          src={img}
          className='w-[240px] absolute left-[50%] transform -translate-x-[50%] h-[240px] drop-shadow-xl mx-auto  rounded-[20px] -mt-[140px]'
          alt=''
        />
        {/* Social card */}
        <div className='pt-[100px] pb-8'>
          <h1 className='mt-6 mb-1 text-6xl font-semibold  dark:text-white'>
            Andrea Massaro
          </h1>
          <h3 className='mb-4 text-xl text-[#7B7B7B] inline-block dark:bg-[#1D1D1D] px-5 py-1.5 rounded-lg dark:text-[#A6A6A6] font-bold'>
            RICS Registered Valuer | REV | Certificazione Inarcheck
          </h3>

          {/* Social Links */}

          <div className='flex justify-center space-x-3'>
            {/* facebook link add here */}
            <a
              href='https://www.facebook.com/GeomAndreaMassaro'
              target='_blank'
              rel='noopener noreferrer'
            >
              <span className='socialbtn text-[#1773EA]'>
                <FaFacebookF />
              </span>
            </a>
            {/* twitter link add here */}
            <a
              href='https://www.google.com/maps/place/Studio+tecnico+Geometra+Andrea+Massaro/@41.8538412,12.50014,17.44z/data=!4m5!3m4!1s0x13258b4f598d9f25:0x11d3ae92dc2c3752!8m2!3d41.853175!4d12.5036024'
              target='_blank'
              rel='noopener noreferrer'
            >
              <span className='socialbtn text-[#1C9CEA]'>
                <FaGoogle />
              </span>
            </a>
            {/* drop link add here 
            <a
              href="https://dribbble.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="socialbtn text-[#e14a84] ">
                <FaDribbble />
              </span>
            </a>
            */}
            {/* linkedin link add here */}
            <a
              href='https://www.linkedin.com/in/andrea-massaro-a78b963b/'
              target='_blank'
              rel='noopener noreferrer'
            >
              <span className='socialbtn text-[#0072b1]'>
                <FaLinkedinIn />
              </span>
            </a>
          </div>

          {/* personal information */}
          <div className='p-7 rounded-2xl mt-7  bg-[#F3F6F6] dark:bg-[#1D1D1D]'>
            <div className='flex border-b border-[#E3E3E3] dark:border-[#3D3A3A] pb-2.5'>
              <span className='flex-shrink-0 socialbtn bg-white dark:bg-black text-[#E93B81] shadow-md'>
                <a href='tel:+393382854477'>
                  <FaMobileAlt />
                </a>
              </span>
              <div className='text-left ml-2.5'>
                <p className='text-xs text-[#44566C] dark:text-[#A6A6A6]'>
                  Telefono
                </p>
                <p className='dark:text-white break-words'>
                  {' '}
                  <a
                    className='hover:text-[#FA5252] duration-300 transition'
                    href='tel:+393382854477'
                  >
                    +39 338 2854477
                  </a>
                </p>
              </div>
            </div>

            <div className='flex  border-b border-[#E3E3E3] dark:border-[#3D3A3A] py-2.5'>
              <span className='flex-shrink-0 socialbtn bg-white dark:bg-black text-[#6AB5B9] shadow-md'>
                <a href='mailto:studiotecnicomassaro@libero.it'>
                  <FaEnvelopeOpenText />
                </a>
              </span>
              <div className='text-left ml-2.5'>
                <p className='text-xs text-[#44566C] dark:text-[#A6A6A6]'>
                  Email
                </p>
                <p className='dark:text-white break-words text-[13px] xl:text-base'>
                  {' '}
                  <a
                    className='hover:text-[#FA5252] duration-300 transition'
                    href='mailto:studiotecnicomassaro@libero.it'
                  >
                    studiotecnicomassaro@libero.it
                  </a>
                </p>
              </div>
            </div>

            <div className='flex border-b border-[#E3E3E3] dark:border-[#3D3A3A] py-2.5'>
              <span className='flex-shrink-0 socialbtn bg-white dark:bg-black text-[#FD7590] shadow-md'>
                <a
                  className='hover:text-[#FA5252] duration-300 transition'
                  href='https://www.google.com/maps/place/Studio+tecnico+Geometra+Andrea+Massaro/@41.853176,12.5030539,19z/data=!3m1!4b1!4m5!3m4!1s0x13258b4f598d9f25:0x11d3ae92dc2c3752!8m2!3d41.853175!4d12.5036024'
                >
                  <FaMapMarkerAlt />
                </a>
              </span>
              <div className='text-left ml-2.5'>
                <p className='text-xs text-[#44566C] dark:text-[#A6A6A6]'>
                  Indirizzo
                </p>
                <p className='dark:text-white break-words'>
                  <a
                    className='hover:text-[#FA5252] duration-300 transition'
                    href='https://www.google.com/maps/place/Studio+tecnico+Geometra+Andrea+Massaro/@41.853176,12.5030539,19z/data=!3m1!4b1!4m5!3m4!1s0x13258b4f598d9f25:0x11d3ae92dc2c3752!8m2!3d41.853175!4d12.5036024'
                  >
                    Via Nino Costa 17, 00147 Roma
                  </a>
                </p>
              </div>
            </div>

            <div className='flex  py-2.5'>
              <span className='flex-shrink-0 socialbtn bg-white dark:bg-black text-[#C17CEB] shadow-md'>
                <FaCalendarAlt />
              </span>
              <div className='text-left ml-2.5'>
                <p className='text-xs text-[#44566C] dark:text-[#A6A6A6]'>
                  Orari di apertura
                </p>
                <p className='dark:text-white break-all'>Lun-Ven dalle 07-18</p>
              </div>
            </div>
          </div>

          <a
            href={cvFile}
            download
            className='inline-flex items-center mx-auto bg-gradient-to-r from-[#FA5252] to-[#DD2476] duration-200 transition ease-linear hover:bg-gradient-to-l from-[#DD2476]  to-[#fa5252ef] px-8 py-3 text-lg text-white rounded-[35px] mt-6'
          >
            <img src={downloadIcon} alt='icon' className='mr-2' />
            Scarica CV
          </a>
        </div>
      </div>
    </div>
  );
};

export default HomeCard;
